/**
 * @module setClientConfiguration
 */

import { mutatorAction } from 'satcheljs';
import ClientConfigurationCache from '../store/schema/clientConfigurationCache';
import store from '../store/store';

/**
 * @MutatorAction
 * A mutator sets the client configuration data in the store
 */

const setClientConfiguration = mutatorAction(
    'setClientConfiguration',
    (clientConfig: ClientConfigurationCache): void => {
        store.cache = clientConfig;
    }
);

export default setClientConfiguration;
